import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "resources-and-references"
    }}>{`Resources and References`}</h1>
    <p>{`To inform and inspire your design process, we've compiled a list of resources and references to help you create engaging, consistent and functional user experiences for your Adobe Express add-ons.`}</p>
    <h2 {...{
      "id": "video-tutorials"
    }}>{`Video Tutorials`}</h2>
    <p>{`Design tips for creating Adobe Express add-ons, by Steph Corrales (Sr. Experience Designer, Adobe Developer Experience).`}</p>
    <br /><br /><div style={{
      "display": "flex",
      "justifyContent": "center"
    }}>
 <iframe width="560" height="315" src="https://www.youtube.com/embed/siWxy4BwkIE?si=LSjjwF1W0JNziDMg" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    </div><br />
    <p>{`Adobe Express add-on's with Spectrum Web Components `}<a parentName="p" {...{
        "href": "../../../learn/how_to/tutorials/spectrum-workshop/index.md"
      }}>{`workshop`}</a>{`, by Holly Schinsky (Sr. Developer Relations Engineer, Adobe Developer Experience).`}</p>
    <br /><br /><div style={{
      "display": "flex",
      "justifyContent": "center"
    }}>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/5PA4KEN4JdQ?si=vcJRsJNx948VFd3l" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    </div><br />
    {/* ## Tools and Templates
     **TODO:** Ask the Design team to provide a list of resources they would like to include here. */}
    <h2 {...{
      "id": "further-reading"
    }}>{`Further Reading`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/"
        }}>{`Adobe Spectrum`}</a>{`: Adobe's design system.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/"
        }}>{`Spectrum Web Components`}</a>{`: Web components implementation of Spectrum.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://s2.spectrum.adobe.com/"
        }}>{`Adobe Spectrum 2`}</a>{`: the next major version of Spectrum, currently in preview.`}</li>
    </ul>
    {/* ## Acknowledgments
     **TODO:** Ask the Design team what content is supposed to go here. */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      